import { render, staticRenderFns } from "./CalculatorButton.vue?vue&type=template&id=811b2152&"
import script from "./CalculatorButton.vue?vue&type=script&lang=js&"
export * from "./CalculatorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports